export const TrackingEvents = {
  ToggleSet: "Toggle Set",
};
